import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import { useCallback } from "react";

function BackgroundParticles() {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const config = {
    fullScreen: { zIndex: -1 },
    particles: {
      number: { value: 100 },
      color: { value: ["#494949ff"] },
      move: {
        enable: true,
        speed: 0.5,
      },
      size: { value: 2 },
    },
    interactivity: {
      events: {
        onHover: { enable: true, mode: "grab" },
      },
      modes: {
        grab: {
          distance: 200,
          links: {
            opacity: 0.8,
            color: "#363636ff",
          },
        },
      },
    },
  };

  return <Particles id="tsparticles" init={particlesInit} options={config} />;
}

export default BackgroundParticles;
